import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { activeNavItemState } from "../../../utils";
import { navLink } from "../../../datos";
import { useAuth } from "../../../hooks";

const GROUP_ORDER = ["Principal", "Recursos Humanos", "Marketing", "Catálogo", "Sistema"];

const grouped = GROUP_ORDER
  .map((name) => ({ name, links: navLink.filter((l) => l.group === name) }))
  .filter((g) => g.links.length > 0);

export function Sidebar({ collapsed = false }) {
  const { pathname } = useLocation();
  const { logout } = useAuth();

  return (
    <nav className="flex flex-col h-full px-2 py-4">
      <div className="flex-1 space-y-0.5">
        {grouped.map((group, gi) => (
          <div key={group.name}>
            {/* Group separator / label */}
            {gi > 0 && (
              collapsed ? (
                <div className="h-px bg-white/10 mx-2 my-2" />
              ) : (
                <p className="px-3 pt-4 pb-1 text-[10px] font-bold text-white/30 uppercase tracking-widest">
                  {group.name}
                </p>
              )
            )}
            {collapsed && gi === 0 && <div className="mb-1" />}

            {group.links.map((link) => (
              <NavItem key={link.id} link={link} pathname={pathname} collapsed={collapsed} />
            ))}
          </div>
        ))}
      </div>

      {/* Logout */}
      <div className="pt-4 border-t border-white/10">
        <button
          onClick={logout}
          title="Cerrar Sesión"
          className={`w-full flex items-center py-3 text-white/75 hover:text-white hover:bg-white/10 rounded-xl transition-all duration-200 group ${collapsed ? "justify-center px-2" : "gap-3 px-3"}`}
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-xl bg-white/10 group-hover:bg-[#C81416]/20 transition-colors flex-shrink-0">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </span>
          {!collapsed && <span className="text-sm font-medium truncate">Cerrar Sesión</span>}
        </button>
      </div>
    </nav>
  );
}

function NavItem({ link, pathname, collapsed }) {
  const [, setActiveNav] = useRecoilState(activeNavItemState);
  const isActive = pathname === link.url || (link.url !== "/admin" && pathname.startsWith(link.url));

  return (
    <Link
      onClick={() => setActiveNav(link.id)}
      to={link.url}
      title={link.title}
      className={`flex items-center py-3 rounded-xl transition-all duration-200 group relative ${
        collapsed ? "justify-center px-2" : "gap-3 px-3"
      } ${
        isActive
          ? "bg-[#C81416] text-white shadow-[0_4px_14px_rgba(200,20,22,0.4)]"
          : "text-white/75 hover:bg-white/10 hover:text-white"
      }`}
    >
      {isActive && !collapsed && (
        <span className="absolute left-0 top-1/2 -translate-y-1/2 w-0.5 h-6 bg-white rounded-r-full -ml-2" />
      )}

      <span className={`w-9 h-9 flex items-center justify-center rounded-xl text-base flex-shrink-0 transition-transform duration-200 group-hover:scale-110 ${
        isActive ? "bg-white/20" : "bg-white/10"
      }`}>
        {link.icon}
      </span>

      {!collapsed && (
        <span className="text-sm font-semibold truncate">{link.title}</span>
      )}

      {isActive && !collapsed && (
        <span className="ml-auto w-1.5 h-1.5 rounded-full bg-white/70 flex-shrink-0" />
      )}
    </Link>
  );
}
